import { useSelector } from "react-redux";
import dbQuestion from "../../data/data";
import { useEffect, useState } from "react";

export const BubbleBotActual = () => {
  const [questionActual, setQuestionActual] = useState("");
  const formDataDic = useSelector((state) => {
    return state.formDataDic;
  });
  const price = useSelector((state) => {
    return state.price;
  });

  useEffect(() => {
    if (formDataDic?.formData) {
      setQuestionActual(
        dbQuestion?.find((e) => e.id === formDataDic?.formData?.length)
          ?.question
      );
    } else {
      setQuestionActual(
        "Oops petit problème de connexion, pouvez-vous vous reconnecter ou envoyer nous un mail à ramael.bruno@gmail.com"
      );
    }
  }, [formDataDic]);

  return (
    <div className="flex flex-col">
      {formDataDic?.formData?.length < dbQuestion?.length ? (
        <div className="flex flex-col justify-start">
          <div className="chat-header pl-4">Assistant</div>
          <div className="chat chat-start w-full flex flex-row">
            <div className="chat-image avatar">
              <div className="w-10 rounded-full">
                <img
                  alt="robot parlant"
                  width={24}
                  height={24}
                  src="./image/robot_3_4.png"
                />
              </div>
            </div>
            <div className="chat-bubble w-full">
              {questionActual?.replace("$_argent", price ? price : "")}
            </div>
          </div>
        </div>
      ) : (
        <div className="chat chat-start w-full">
          <div className="chat-image avatar">
            <div className="w-10 rounded-full">
              <img
                alt="robot parlant"
                width={24}
                height={24}
                src="./image/robot_3_4.png"
              />
            </div>
          </div>
          <div className="chat-header">Assistant</div>
          <div className="chat-bubble w-full">
            Ça y est, vous avez répondu à toutes les questions ! Il ne vous
            reste plus qu'une étape : veuillez entrer votre numéro de téléphone
            et valider en cliquant sur le bouton 'Finaliser et traiter mes
            réponses'. Nous vous rappellerons dans un délai maximum de 5 jours.
          </div>
        </div>
      )}
    </div>
  );
};
